import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import store from './data/store';
import App from './app';

/**
 * entry point
 */
const init = () => {
    const $root = document.getElementById('dealer-app');
    if (!$root) return;

    ReactDOM.render(
        <React.StrictMode>
            <Provider store={store}>
                <App />
            </Provider>
        </React.StrictMode>,
        $root
    );
};

document.addEventListener('DOMContentLoaded', () => {
    init();
});

export {}

